



































































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';

@Component({ name: 'OpportunityLocationAddressEdit' })
export default class extends GiganautVueDialog {
  addressSearchText = '';
  entity = {
    prospectLocationAddress1: '',
    prospectLocationAddress2: '',
    prospectLocationLocality: '',
    prospectLocationCity: '',
    prospectLocationRegion: '',
    prospectLocationPostcode: '',
    prospectLocationCountry: '',
    prospectLocationLatitude: null as number | null,
    prospectLocationLongitude: null as number | null,
  };

  get opportunity() { return OpportunityDetailsModule.opportunity; }
  get saving() { return OpportunityDetailsModule.saving; }

  onPlaceChanged(addressData: any, placeData: any) {
    this.entity.prospectLocationAddress1 = addressData.street_number || '';
    this.entity.prospectLocationAddress2 = addressData.route || '';
    this.entity.prospectLocationLocality = addressData.locality || '';
    if (placeData && placeData.address_components) {
      for (const el of placeData.address_components) {
        if (el.types[0] === 'postal_town') this.entity.prospectLocationCity = el.long_name;
        if (el.types[0] === 'country') this.entity.prospectLocationCountry = el.short_name;
      }
    }
    this.entity.prospectLocationRegion = addressData.administrative_area_level_2 || '';
    this.entity.prospectLocationPostcode = addressData.postal_code || '';
    this.entity.prospectLocationLatitude = addressData.latitude ?? null;
    this.entity.prospectLocationLongitude = addressData.longitude ?? null;
  }

  @Watch('dialog')
  onDialogChanged(val: boolean) {
    if (!val || !this.opportunity) return;
    const o = this.opportunity;
    this.addressSearchText = '';
    this.entity.prospectLocationAddress1 = o.prospectLocationAddress1;
    this.entity.prospectLocationAddress2 = o.prospectLocationAddress2;
    this.entity.prospectLocationLocality = o.prospectLocationLocality;
    this.entity.prospectLocationCity = o.prospectLocationCity;
    this.entity.prospectLocationRegion = o.prospectLocationRegion;
    this.entity.prospectLocationPostcode = o.prospectLocationPostcode;
    this.entity.prospectLocationCountry = o.prospectLocationCountry;
    this.entity.prospectLocationLatitude = o.prospectLocationLatitude;
    this.entity.prospectLocationLongitude = o.prospectLocationLongitude;
  }

  async save() {
    if (!(this.$refs.form as any).validate() || !this.opportunity) return;
    await OpportunityDetailsModule.updateProspectLocationAddress({
      id: this.opportunity.id,
      updatedAt: this.opportunity.updatedAt,
      ...this.entity,
    });
    this.dialog = false;
  }
}
